/* eslint-disable max-len */
import { Component, OnInit, OnDestroy, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DisplayService } from '../../services/display/display.service';
import { DataService } from '../../services/data/data.service';
import { CommsService } from '../../services/comms/comms.service';
import { ConfigService } from '../../services/config/config.service';
import { InvoiceService } from '../../services/invoice/invoice.service';
import { NoteService } from '../../services/note/note.service';
import { TimesheetService } from '../../services/timesheet/timesheet.service';

@Component({
	selector: 'pcm-data-page-invoice',
	templateUrl: './data-page-invoice.component.html',
	styleUrls: ['./data-page-invoice.component.scss']
})
export class DataPageInvoiceComponent implements OnInit, OnDestroy {

	title = 'Invoice Record Summary';

	timesheetColumsConfig = [];
	chaincodeColumsConfig = [];
	supplierColumsConfig = [];
	originalComments = '';
	originalFailureReason = '';
	updatingComments = false;
	invoiceData: any = {};
	invoiceDataConfig: any = {};
	collapseToNumRows = 11;

	showConfirmation = false;
	confirmationMessage = 'Are you sure you want to run invoice reconciliation manually?  This process may take up to a few minutes. After clicking \'Continue\', please refresh the page to check for updated data. ';

	showExport = false;

	constructor(
		public router: Router,
		public route: ActivatedRoute,
		public displayService: DisplayService,
		public dataService: DataService,
		public commsService: CommsService,
		public configService: ConfigService,
		public invoiceService: InvoiceService,
		public noteService: NoteService,
		public timesheetService: TimesheetService
	) {}

	ngOnInit() {
		let needFailureReasons = false;
		if (this.configService.persona === this.configService.personaProps['fa']) {
			if (!this.invoiceService.failureReasons) {
				needFailureReasons = true;
			}
		}

		this.route.params.subscribe(params => {
			this.loadInvoice(params['poNumber'], params['supplierId'], params['billingStart'], params['billingEnd'], needFailureReasons);
		});
	}

	ngOnDestroy() {
		this.dataService.clearInvoiceDetails();
	}

	loadInvoice(poNumber: string, supplierId: string, billingStart: string, billingEnd: string, needFailureReasons: boolean = false) {
		const dataBody = {
			ponumber: poNumber,
			supplierid: supplierId,
			billingstart: billingStart,
			billingend: billingEnd
		};

		this.displayService.startLoading();
		this.commsService.getInvoiceReconciliation(dataBody, needFailureReasons).subscribe((res) => {
			console.log('GET INVOICE RECONCILIATION', res);
			let successData;
			if (needFailureReasons) {
				this.invoiceService.failureReasons = this.commsService.getSuccessData(res.failureReasons);
				successData = this.commsService.getSuccessData(res.invoice);
			} else {
				successData = this.commsService.getSuccessData(res);
			}
			successData[this.configService.invoiceStatusProp] = this.invoiceService.getInvoiceStatus(successData);
			this.dataService.updateInvoiceDetails(successData);
			this.invoiceData = this.dataService.invoiceDetails;

			this.invoiceDataConfig = this.configService.getDataObj(this.invoiceService.dataObj, null, successData[this.configService.countryCodeProp]);
			this.timesheetColumsConfig = this.configService.getTableFields(this.timesheetService.dataObj, true, successData[this.configService.countryCodeProp]);
			this.timesheetService.selectDefaultTab(this.timesheetService.tabsData.invoiceListTabs);

			this.chaincodeColumsConfig = this.configService.getTableFields(this.invoiceService.bcDataObj, true, successData[this.configService.countryCodeProp]);
			this.invoiceService.selectDefaultTab(this.invoiceService.tabsData.detailsListTabs);

			this.supplierColumsConfig = this.configService.getTableFields(this.invoiceService.supDataObj, true, successData[this.configService.countryCodeProp]);
			this.invoiceService.selectDefaultTab(this.invoiceService.tabsData.detailsSupListTabs);

			// save for reset
			this.originalComments = this.invoiceData['comments'];
			this.originalFailureReason = this.invoiceData['failurereason'];

			this.displayService.endLoading();
		}, (err) => {
			this.displayService.endLoading();
			this.commsService.handleAPIError('GET INNVOICE RECONCILIATION', err);
			this.router.navigateByUrl(this.invoiceService.listRoot);
		});
	}

	resetComments() {
		this.invoiceData['comments'] = this.originalComments;
		this.invoiceData['failurereason'] = this.originalFailureReason;
	}

	updateComments() {
		this.updatingComments = true;
		const data = {};
		data['id'] = this.invoiceData['_id'];
		data['comments'] = this.invoiceData['comments'];
		data['failurereason'] = this.invoiceData['failurereason'];
		this.commsService.updateInvoiceConmments(data).subscribe((res) => {
			console.log('Update Invoice Reconciliation Comments: ', res);
			this.updatingComments = false;
			this.originalComments = this.invoiceData['comments'];
			this.originalFailureReason = this.invoiceData['failurereason'];
			this.invoiceService.loadInvoicesForTab(this.invoiceService.getActiveTab(this.invoiceService.tabsData.listTabs));
		}, (err) => {
			this.updatingComments = false;
			this.commsService.handleAPIError('Update Invoice Reconciliation Comments', err);
		});
	}

	showComments(): boolean {
		return this.configService.persona === this.configService.personaProps['fa'] || this.configService.persona === this.configService.personaProps['readonly'];
	}

	showFailureReason() {
		let show = false;
		if (this.invoiceData && (this.invoiceData.reconciliationstatus === 'Pending' || this.invoiceData.reconciliationstatus === 'Failed')) {
			show = true;
		}
		return show;
	}

	pageFormSubmit(event) {
		this.invoiceService.submitInvoiceNumber();
	}

	cancelConfirmation() {
		this.showConfirmation = false;
	}

	confirmAction() {
		this.showConfirmation = true;
	}

	runInvoiceReconciliation() {
		const data = {};
		data['ponumbers'] = [this.invoiceData['ponumber']];
		data[this.configService.supplierIdProp] = this.invoiceData[this.configService.supplierIdProp];
		data[this.configService.invoiceStartProp] = this.invoiceData[this.configService.invoiceStartProp];
		data[this.configService.invoiceEndProp] = this.invoiceData[this.configService.invoiceEndProp];
		this.displayService.startLoading();
		this.commsService.runInvoiceReconciliation(data).subscribe((res) => {
			this.displayService.endLoading();
			this.noteService.displaySuccess('The request to run invoice reconciliation has been sent successfully.');
		}, (err) => {
			this.displayService.endLoading();
			this.commsService.handleAPIError('Run Invoice Reconciliation', err);
		});
		this.cancelConfirmation();
	}

	showExportModal() {
		this.showExport = true;
	}

	closeExportModal() {
		this.showExport = false;
	}

	exportToPDF(event) {
		const delay = setTimeout( () => {
			this.closeExportModal();
		}, 1000);
		const content = document.getElementById('invoice-data-page-body');
		this.dataService.downloadToPDF(content, event.data)
	}
}
